import React, { useState } from 'react';
import Slider from '@mui/material/Slider';
import PropTypes from 'prop-types';
import { withAuctionCore } from 'agent';
import useStores from 'hooks/useStore';
import useReports from 'hooks/useReports';
import { Container, Title, SelectedLabel, StyledSlider } from '../styles';

const ConditionSlider = ({ item, selected, auctioncore }) => {
  const [value, setValue] = useState(0);
  const { UIStore } = useStores();
  const {
    setReports,
  } = useReports(auctioncore);

  const { condition, setLoading } = UIStore;

  const selectedIndex = item.ratings.length - item.ratings.findIndex((x) => x === selected) - 1;

  const UpdatedResults = async () => {
    const updatedConditions = condition;

    const i = updatedConditions.findIndex(((obj) => obj.name === item.name));

    const index = item.ratings.length - value - 1;

    if (updatedConditions[i].rating !== item.ratings[index]) {
      setLoading(true);
      updatedConditions[i].rating = item.ratings[index];
      await setReports(updatedConditions);
      setLoading(false);
    }
  };

  return (
    <Container>
      <Title>{item.name}</Title>
      <StyledSlider
        aria-label="Small steps"
        defaultValue={selectedIndex}
        step={1}
        onChangeCommitted={UpdatedResults}
        marks
        min={0}
        color="secondary"
        getAriaValueText={setValue}
        max={item.ratings.length - 1}
      />

      <SelectedLabel>{item.ratings[item.ratings.length - value - 1]}</SelectedLabel>
    </Container>
  );
};

ConditionSlider.propTypes = {
  item: PropTypes.object.isRequired,
  auctioncore: PropTypes.object.isRequired,
  selected: PropTypes.string.isRequired,
};

export default withAuctionCore(ConditionSlider);
